export default __webpack_public_path__ + "static/media/izipay.dcdc47ab.png";